function mountJustWatchWidget() {
  const encodedPath = this.pageParams.jwpath;
  this.logger.debug('Just Watch encoded path:', encodedPath);
  if (encodedPath) {
    const parsedPath = encodedPath.replace(/\./g, '/');
    this.logger.debug('Just Watch parsed path:', parsedPath);
    this.logger.debug('Just Watch test url:', `https://www.justwatch.com${parsedPath}`);
    const mountingNode = this.doc.getElementById(this.dataset.dabuPlacementId);
    if (mountingNode) {
      const widget = this.doc.createElement('div');
      widget.dataset.jwWidget = true;
      widget.dataset.apiKey = 'RsVK6uj83uYwPAWulqwDxdnlzkgsMFxn';
      widget.dataset.urlPath = parsedPath;

      const script = this.doc.createElement('script');
      script.async = true;
      script.src = 'https://widget.justwatch.com/justwatch_widget.js';

      /* Just Watch requires attribution. Here, we build the below elements that they provided
       *  <a
       *    style="font-size: 11px; font-family: sans-serif; color: black; text-decoration: none;"
       *    target="_blank"
       *    data-original="https://www.justwatch.com"
       *    href="https://www.justwatch.com"
       *   >
       *    Powered by
       *    <span
       *      style="display: -moz-inline-box; display: inline-block; width: 66px; height: 10px; margin-left: 3px; background: url(https://widget.justwatch.com/assets/JW_logo_black_10px.svg); overflow: hidden; text-indent: -3000px;"
       *    >
       *      JustWatch
       *      </span>
       * </a>
       */

      const attribution = this.doc.createElement('a');
      attribution.style = 'font-size: 11px; font-family: sans-serif; color: black; text-decoration: none;';
      attribution.target = '_blank';
      attribution.dataset.original = 'https://www.justwatch.com/us';
      attribution.href = 'https://www.justwatch.com/us';
      attribution.innerText = 'Powered by';
      const logo = this.doc.createElement('span');
      logo.style = 'display: -moz-inline-box; display: inline-block; width: 66px; height: 10px; margin-left: 3px; background: url(https://widget.justwatch.com/assets/JW_logo_black_10px.svg); overflow: hidden; text-indent: -3000px;';
      logo.innerText = 'JustWatch';
      attribution.append(logo);

      mountingNode.append(widget);
      mountingNode.append(script);
      mountingNode.append(attribution);
    } else {
      this.logger.error(new Error('Mounting node not found'));
    }
  }
}

export default mountJustWatchWidget;
